import {ITripExpense, TripExpense} from './../models/tripExpense.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class TripExpenseService {

  constructor(private http: HttpClient) {}

  getTripExpense(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/trip_expense/all`, {'headers': headers});
  }

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/trip_expense` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getTripExpenseBycurrentSearch(search: string, page: number, size: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/trip_expense` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size), {'headers': headers});
  }

  saveTripExpense(tripExpense: ITripExpense) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/trip_expense`, tripExpense, {'headers': headers});
  }

  getIdTripExpense(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/trip_expense/` + idA, {'headers': headers});
  }

  updateTripExpense(tripExpense: ITripExpense) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/trip_expense/` + tripExpense.id, tripExpense, {'headers': headers});
  }

  deleteTripExpense(idA: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/trip_expense/` + idA, {'headers': headers});
  }

}
